export const CO_BRANDING_BANNER_LOCALSTORAGE_STATE_KEY = 'pj:coBrandingBanner';
